import { render, staticRenderFns } from "./EventModificationDetails.vue?vue&type=template&id=c33e5ccc&"
import script from "./EventModificationDetails.vue?vue&type=script&lang=js&"
export * from "./EventModificationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports